import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "../inputField/InputField";
import EmailInputWithSuggestions from "../emailInputWithSuggestions/EmailInputWithSuggestions";
import ButtonGradient from "../ui/ButtonGradient";
import {
  Container,
  Title,
  FieldGroup,
  ButtonsWrapper,
} from "./ProfileInfoEditStyles";
import { motion } from "framer-motion";
import { fadeUp } from "../../styles/animations";

import User from "../../img/form/user.png";
import Mail from "../../img/form/mail.png";
import Call from "../../img/form/call.png";

interface UserData {
  name: string;
  lastName: string;
  artistName: string;
  email: string;
  phone: string;
}

const ProfileInfoEdit = () => {
  const [formData, setFormData] = useState<UserData>({
    name: "",
    lastName: "",
    artistName: "",
    email: "",
    phone: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem("user_data");
    if (data) {
      setFormData(JSON.parse(data));
    } else {
      // fallback temporário
      setFormData({
        name: "Matheus",
        lastName: "Iubel",
        artistName: "IUBL",
        email: "iubl@music.com",
        phone: "+55 (47) 99999-0000",
      });
    }
  }, []);

  const handleChange = (field: keyof UserData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    localStorage.setItem("user_data", JSON.stringify(formData));
    navigate("/perfil");
  };

  return (
    <Container as={motion.div} initial="hidden" animate="visible">
      <Title as={motion.h1} variants={fadeUp} custom={0}>
        Editar Perfil
      </Title>

      <FieldGroup as={motion.div} variants={fadeUp} custom={1}>
        <InputField
          icon={<img src={User} alt="ícone usuário" />}
          label="Nome"
          name="name"
          placeholder="Seu nome"
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />
      </FieldGroup>

      <FieldGroup as={motion.div} variants={fadeUp} custom={2}>
        <InputField
          icon={<img src={User} alt="ícone usuário" />}
          label="Sobrenome"
          name="lastName"
          placeholder="Seu sobrenome"
          value={formData.lastName}
          onChange={(e) => handleChange("lastName", e.target.value)}
        />
      </FieldGroup>

      <FieldGroup as={motion.div} variants={fadeUp} custom={3}>
        <InputField
          icon={<img src={User} alt="ícone usuário" />}
          label="Nome Artístico"
          name="artistName"
          placeholder="Seu nome artístico"
          value={formData.artistName}
          onChange={(e) => handleChange("artistName", e.target.value)}
        />
      </FieldGroup>

      <FieldGroup as={motion.div} variants={fadeUp} custom={4}>
        <EmailInputWithSuggestions
          icon={<img src={Mail} alt="ícone email" />}
          label="E-mail"
          name="email"
          placeholder="Seu e-mail"
          value={formData.email}
          onChange={(val) => handleChange("email", val)}
        />
      </FieldGroup>

      <FieldGroup as={motion.div} variants={fadeUp} custom={5}>
        <InputField
          icon={<img src={Call} alt="ícone telefone" />}
          label="Telefone"
          name="phone"
          placeholder="Seu telefone"
          value={formData.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
        />
      </FieldGroup>

      <ButtonsWrapper as={motion.div} variants={fadeUp} custom={6}>
        <ButtonGradient onClick={handleSave}>Salvar</ButtonGradient>
        <ButtonGradient onClick={() => navigate("/perfil")}>
          Cancelar
        </ButtonGradient>
      </ButtonsWrapper>
    </Container>
  );
};

export default ProfileInfoEdit;
